import { useEffect, useState } from 'react';
import { TOPBAR_NODE_ID } from '../app/layout/PageLayout';

const useTopbarHeight = () => {
  const [topbarHeight, setTopbarHeight] = useState<number | null>(null);

  useEffect(() => {
    const topbar = document.getElementById(TOPBAR_NODE_ID);
    if (!topbar) return undefined;

    const observer = new ResizeObserver((entries) => {
      setTopbarHeight(entries?.[0]?.contentRect?.height ?? null);
    });

    observer.observe(topbar);

    return () => {
      observer.disconnect();
    };
  }, []);

  return topbarHeight;
};

export default useTopbarHeight;
